/**
 * The payment page's status token, kept out of analytics (DEL-442).
 *
 * /bayar/:orderNumber?t=… carries the buyer's key to their own order: guest
 * checkout has no session to hang it off, so it travels in the URL. Anything
 * that records URLs, Mixpanel's page views, its click events, its session
 * replays, would otherwise keep a working key to every order it saw.
 *
 * The value is replaced, not the parameter dropped, so a URL still reads as
 * the payment page with a token, and a report can tell it from one without.
 */

const STATUS_TOKEN = /([?&])t=[^&#"'\s\\]*/g;

export const REDACTED = "redacted";

/** `text` with every `?t=` / `&t=` value replaced. Works on a URL or on JSON holding URLs. */
export function redactStatusToken(text: string): string {
  return text.replace(STATUS_TOKEN, `$1t=${REDACTED}`);
}

/** Every string property redacted. For Mixpanel's before_send hook. */
export function redactProperties<T extends Record<string, unknown>>(props: T): T {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(props)) out[k] = typeof v === "string" ? redactStatusToken(v) : v;
  return out as T;
}
